import { forwardRef, type InputHTMLAttributes, type Ref } from "react";
import styles from "./Input.module.css";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  ref?: Ref<HTMLInputElement>;
  label?: string;
  secondaryLabel?: string;
  rightIcon?: JSX.Element;
  onClickRightIcon?: () => void;
  leftIcon?: JSX.Element;
  onClickLeftIcon?: () => void;
  subtitle?: string;
  disabled?: boolean;
  error?: string;
  fullWidth?: boolean;
  containerClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      secondaryLabel,
      name,
      subtitle,
      className,
      leftIcon,
      onClickLeftIcon,
      rightIcon,
      onClickRightIcon,
      error,
      fullWidth,
      disabled,
      containerClassName,
      ...rest
    }: InputProps,
    ref
  ) => {
    return (
      <div
        className={`${fullWidth ? styles.container : `inline-block`} relative ${
          containerClassName ?? ``
        }`}
      >
        {label && (
          <label className={styles.label} htmlFor={name}>
            {label}{" "}
            <span className="font-thin text-gray-400">
              {secondaryLabel}
            </span>{" "}
          </label>
        )}
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        <div className={`relative ${fullWidth ? `w-full` : `w-fit`}`}>
          {leftIcon && (
            <div
              onClick={() => onClickLeftIcon?.()}
              className={`${styles.leftIcon} ${
                onClickLeftIcon ? "cursor-pointer" : ""
              }`}
            >
              {leftIcon}
            </div>
          )}
          <input
            {...rest}
            name={name}
            aria-label={name}
            role="textbox"
            ref={ref}
            disabled={disabled}
            className={`
        ${styles.input}
        ${leftIcon ? styles.inputWithLeftIcon : ""}
        ${rightIcon ? styles.inputWithRightIcon : ""}
        ${error ? styles.inputWithError : ""}
        ${disabled ? styles.inputDisabled : ""}
        ${fullWidth ? `w-full` : ``}
        ${className}
      `}
          />
          {rightIcon && (
            <div
              onClick={() => onClickRightIcon?.()}
              className={`${styles.rightIcon} ${
                onClickRightIcon ? "cursor-pointer" : ""
              }`}
            >
              {rightIcon}
            </div>
          )}
        </div>
        {error && <span className={styles.error}>{error}</span>}
      </div>
    );
  }
);

Input.displayName = "Input";
